module.exports = __webpack_public_path__ + "img/activate-admin-info.73f306e8.png";